module.exports = __webpack_public_path__ + "static/media/from-tee-to-green.ce075625.png";